import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ShieldCheck, Zap, Image as ImageIcon } from 'lucide-react';

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="auth-shell min-h-screen text-foreground">
      <div className="auth-bg-grid" />
      <Link to="/" className="auth-brand">
        <div className="auth-brand-mark"><Sparkles className="w-4 h-4" /></div>
        <span>CihanStock</span>
      </Link>
      <div className="auth-layout">
        <aside className="auth-showcase">
          <div className="auth-showcase-card auth-tilt-card">
            <p className="auth-eyebrow">Premium Creative Panel</p>
            <h1>Stok görsel, ölçü numunesi ve bakiye yönetimi tek yerde.</h1>
            <div className="auth-feature-row"><Zap className="w-4 h-4" /> Link yapıştır, fiyatı gör, indir</div>
            <div className="auth-feature-row"><ImageIcon className="w-4 h-4" /> 60×90 cm gibi ölçüleri şık numuneye çevir</div>
            <div className="auth-feature-row"><ShieldCheck className="w-4 h-4" /> E-posta onaylı güvenli üyelik</div>
          </div>
        </aside>
        <main className="auth-panel-wrap">
          <div className="auth-panel auth-tilt-card">
            <div className="mb-7">
              <div className="auth-icon"><Sparkles className="w-5 h-5 text-white" /></div>
              <h1 className="text-3xl font-extrabold tracking-tight mt-4">{title}</h1>
              <p className="text-sm text-muted-foreground mt-2">{subtitle}</p>
            </div>
            {children}
            {footer}
          </div>
        </main>
      </div>
    </div>
  );
}
